import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Page404teacher() {
  return (
    <>
      <Helmet>
        <title> 404 Page Not Found | Online Lala English </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
          Здається щось пішло не так!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
          Сторінка, яку ви запитуєте, не існує. Можливо вона застаріла, була видалена, або була введена невірна адреса в адресному рядку.
          </Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button to="/teacher" size="large" variant="contained" component={RouterLink}>
            Назад
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
